/**
 * D70 — the ONE gate for the staging "Synthetic sandbox data" treatment.
 *
 * True only when the build-time flag `VITE_SANDBOX_DATA_NOTICE` is exactly the
 * string `'true'`. The indicator, the robots.txt swap (`scripts/sandboxRobotsPlugin.ts`),
 * the Google key build guard (`scripts/sandboxGoogleKeyGuard.ts`) and the Vercel
 * analytics switch all read this and nothing else. Production
 * targets and the committed `.env` never define the flag, so on production every
 * consumer is inert.
 *
 * `flag` is a parameter so the Vite config (which has no `import.meta.env`) can
 * pass the resolved value. Pass `''`, never `undefined`: `undefined` triggers the
 * default, which reads `import.meta.env` (absent in the config process). The
 * default is evaluated lazily, only when no argument is given.
 */
export function isSandboxDataNotice(flag: string | undefined = import.meta.env.VITE_SANDBOX_DATA_NOTICE): boolean {
  return flag === 'true';
}
